function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4D4D4D",
  fillRule: "nonzero",
  d: "M21.337.667a2.662 2.662 0 0 1 2.658 2.499l.005.168v21.332a2.667 2.667 0 0 1-2.494 2.662l-.169.005H10.663a2.662 2.662 0 0 1-2.658-2.499L8 24.666V3.334A2.667 2.667 0 0 1 10.494.672l.169-.005h10.674zm-7.953 2.667h-2.712v4.614l-.005 16.473v.246l10.613-.001h.048v-4.614l.005-16.376v-.097l-7.949-.245zm-8.05 1.333c.736 0 1.333.6 1.333 1.342v15.982c0 .698-.525 1.271-1.204 1.336l-.13.006c-.736 0-1.333-.6-1.333-1.342V6.009c0-.698.524-1.271 1.204-1.336l.13-.006zm21.333 0c.736 0 1.333.6 1.333 1.342v15.982c0 .698-.524 1.271-1.204 1.336l-.13.006c-.736 0-1.333-.6-1.333-1.342V6.009c0-.698.525-1.271 1.204-1.336l.13-.006zM1.333 7.333c.737 0 1.334.59 1.334 1.328v10.678c0 .69-.525 1.257-1.204 1.322l-.13.006c-.736 0-1.333-.59-1.333-1.328V8.661c0-.69.524-1.257 1.204-1.322l.13-.006zm29.334 0c.736 0 1.333.59 1.333 1.328v10.678c0 .69-.524 1.257-1.204 1.322l-.13.006c-.736 0-1.333-.59-1.333-1.328V8.661c0-.69.525-1.257 1.204-1.322l.13-.006z"
});

var SvgVibrateBenefit = function SvgVibrateBenefit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVibrateBenefit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vibrate-benefit.ac310164.svg";
export { ForwardRef as ReactComponent };